// Configuración de Firebase para la versión web de ToPack
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAYo7T1p-fXQ1ZmfJ-UqJCpP0Vfu_9C7P8",
  authDomain: "topack-ceb5a.firebaseapp.com",
  projectId: "topack-ceb5a",
  storageBucket: "topack-ceb5a.appspot.com",
  messagingSenderId: "316902243267",
  appId: "1:316902243267:web:bef8abf3fd7cc5d68e0f05"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios de Firebase
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;